import { useMemo, useState } from 'react'
import { Autocomplete, Box, Chip, Stack, TextField } from '@mui/material'
import ButtonCustom from '../atoms/button/ButtonCustom'
import { filterSubstringOptions, normalizeTagList } from '../../util/tagNormalize'
import ManageEventTagsModal from './ManageEventTagsModal'

const chipSx = {
	'&.MuiChip-root': {
		bgcolor: '#F2F6F8',
		borderRadius: '4px',
	},
	'& .MuiChip-label': {
		fontSize: '12px',
		fontFamily: 'Inter',
		fontWeight: 500,
		color: '#313131',
	},
}

export default function EventTagsField({
	value = [],
	onChange,
	catalog = [],
	kazooId,
	disabled = false,
	label = 'Event Tags',
}) {
	const [manageOpen, setManageOpen] = useState(false)

	const suggestions = useMemo(() => {
		const assigned = new Set((value || []).map((t) => t.toLowerCase()))
		return (catalog || []).filter((t) => !assigned.has(t.toLowerCase()))
	}, [catalog, value])

	const handleChange = (_event, newValue) => {
		onChange?.(normalizeTagList(newValue, catalog))
	}

	return (
		<Box>
			<Stack direction="row" spacing={1} alignItems="flex-start">
				<Autocomplete
					multiple
					freeSolo
					openOnFocus
					disabled={disabled}
					options={suggestions}
					filterOptions={filterSubstringOptions}
					value={value}
					onChange={handleChange}
					sx={{ flex: 1 }}
					slotProps={{
						popper: { sx: { zIndex: 2000 } },
					}}
					renderTags={(tagValue, getTagProps) =>
						tagValue.map((option, index) => {
							const { key, ...tagProps } = getTagProps({ index })
							return (
								<Chip
									key={key}
									label={option}
									size="small"
									sx={chipSx}
									{...tagProps}
								/>
							)
						})
					}
					renderInput={(params) => (
						<TextField
							{...params}
							size="small"
							label={label}
							placeholder={
								value.length ? 'Add another tag' : 'Type or select a tag'
							}
							inputProps={{
								...params.inputProps,
								'data-cy': 'event-tags',
							}}
						/>
					)}
				/>
				<ButtonCustom
					variant="outlined"
					type="button"
					onClick={() => setManageOpen(true)}
					disabled={disabled || !kazooId}
					data-cy="manage-event-tags"
				>
					Manage tags
				</ButtonCustom>
			</Stack>
			{kazooId ? (
				<ManageEventTagsModal
					open={manageOpen}
					onClose={() => setManageOpen(false)}
					kazooId={kazooId}
					catalog={catalog}
				/>
			) : null}
		</Box>
	)
}
